import { Button, Spinner } from '@ui';
import { useTranslation } from 'react-i18next';
import useSWRInfinite from 'swr/infinite';
import ChangelogEntry from './ChangelogEntry';
import { ChangelogPage } from './types';

const getKey = (pageIndex: number, previous: ChangelogPage | null) => {
    if (previous?.meta && previous.meta.current_page >= previous.meta.last_page) return null;
    return `changelogs?page=${pageIndex + 1}`;
};

const ChangelogArchive = () => {
    const { t } = useTranslation('common');
    const { data, size, setSize, isValidating } = useSWRInfinite<ChangelogPage>(getKey);

    const changelogs = data?.flatMap((page) => page.data) ?? [];
    const lastPage = data?.[data.length - 1]?.meta;
    const hasMore = !!lastPage && lastPage.current_page < lastPage.last_page;

    if (!data) return <Spinner />;
    if (!changelogs.length) return <p className="tw-m-0 tw-text-accents-5">{t('changelog.empty')}</p>;

    return (
        <div className="tw-flex tw-flex-col tw-gap-10">
            {changelogs.map((changelog) => (
                <ChangelogEntry key={changelog.id} changelog={changelog} unread={!changelog.read_at} />
            ))}
            {hasMore && (
                <div className="tw-flex tw-justify-center">
                    <Button color="light" flat isLoading={isValidating} onPress={() => setSize(size + 1)}>
                        {t('changelog.more')}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default ChangelogArchive;
